import { useMutation } from "@apollo/client";
import { Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import Button from "../../../../components/Button/Button";
import ContactSupport from "../../../../components/shared/ContactSupport/ContactSupport";
import {
  setIsSelected,
  setPlanDetailsBySkuError,
  setSelectedPlanDetails,
  setZoomOutFlag,
} from "../../../../Redux/Slices/OrderUpgradeSlice";
import { formatNumberWithCommas } from "../../../../Services/helper";
import { StyledElement } from "../../../../Styles/GlobalStyles";
import { Theme } from "../../../../Styles/GlobalTheme";
import PlanDetailsDialog from "../../../Home/Components/NetworkStatus/PlanDetailsDialog";
import { PlanCardLayout } from "./BroadbandFactsCard";
import { planProps } from "./OrderUpgrades";
import { GET_PLAN_DETAILS_BY_SKU } from "./query";
import { NEW_FIBER_DISCOUNT_MESSAGE, PLAN_DETAILS } from "./constants";

interface PlanCardProps {
  selectPlan: number | null;
  setSelectPlan: React.Dispatch<React.SetStateAction<number | null>>;
  plan: planProps;
  index: number;
  highestPlan: string;
  setShowBroadbandFacts: React.Dispatch<React.SetStateAction<boolean>>;
  futureRouterArray: any;
  setSubmitOrderArr: any;
  submitOrderArr: any;
  setInstallation: any;
  availablePlansForUpgrade: any;
}

const PlansCard = (props: PlanCardProps) => {
  const dispatch = useDispatch();
  const [Details, setDetails] = useState(false);
  const {
    selectPlan,
    setSelectPlan,
    plan,
    index,
    setShowBroadbandFacts,
    highestPlan,
    setSubmitOrderArr,
    submitOrderArr,
    setInstallation,
    availablePlansForUpgrade,
  } = props;

  const handleSelectPlan = (plan: planProps, index: number) => {
    if (selectPlan === index) return;

    setInstallation(null);
    setSubmitOrderArr([]);
    setSelectPlan(index);
    setShowBroadbandFacts(true);
    dispatch(setSelectedPlanDetails(plan));
    let newSubmitArray: any = submitOrderArr?.filter(
      (item: any) => item?.productId === plan?.productId
    );

    let newRowItem: any = plan;
    const updatedItem = { ...newRowItem, isPerMonth: true };
    newSubmitArray.push(updatedItem);
    setSubmitOrderArr(newSubmitArray);

    dispatch(setIsSelected(true));
    dispatch(setZoomOutFlag(false));
  };

  const [getPlandetailsBySku, { data: planDetailsData, loading: planDetailsLoading }] = useMutation(
    GET_PLAN_DETAILS_BY_SKU,
    {
      variables: {
        contentSkuCode: plan?.contentSku ?? "",
      },
      fetchPolicy: "network-only",
      onError: () => dispatch(setPlanDetailsBySkuError(true)),
      onCompleted: () => dispatch(setPlanDetailsBySkuError(false)),
    }
  );

  const planDetails = planDetailsData?.getPlansDetailsContentByContentSku;

  const handlePlanDetails = () => {
    getPlandetailsBySku();
    setDetails(true);
  };

  const handleCloseDialog = () => {
    setDetails(false);
  };

  const hasNewFiberDiscount = plan?.discounts?.some(
    (discount: any) => discount?.discountCode === "NEWFIBERDISCOUNT"
  );

  return (
    <>
      <PlanCardLayout highestPlan={highestPlan === plan?.name}>
        <Stack spacing={highestPlan === plan?.name ? 2 : 1}>
          <Typography fontWeight={600} color={Theme.palette.primary.main}>
            {plan?.name}
          </Typography>
          <Stack
            width={"100%"}
            direction={"row"}
            spacing={{ xs: 0.5, sm: 1 }}
            alignItems={"center"}
            p={1.2}
            sx={{ backgroundColor: Theme.palette.customcolor.skyBlue }}>
            <Typography fontSize={{ xs: "18px", md: "20px" }} fontWeight={600}>
              {formatNumberWithCommas(plan?.priceAfterDiscount ?? plan?.price)}/mo
            </Typography>
            {hasNewFiberDiscount && (
              <>
                <Typography fontSize={"10px"}>
                  {NEW_FIBER_DISCOUNT_MESSAGE}
                </Typography>
              </>
            )}
          </Stack>
          {highestPlan === plan?.name ? (
            <>
              <Stack direction={"row"} spacing={0.2} my={1} flexWrap={"wrap"}>
                <Typography fontSize={{ xs: "14px", md: "14px" }}>Please</Typography>
                <Typography>
                  <ContactSupport text="Contact our Support Team to upgrade" />
                </Typography>
              </Stack>
            </>
          ) : (
            <>
              <Button
                type={selectPlan === index ? "selected" : "pay"}
                title={selectPlan === index ? "SELECTED" : "SELECT"}
                onClick={() => handleSelectPlan(plan, index)}
              />
              <StyledElement onClick={handlePlanDetails}>{PLAN_DETAILS}</StyledElement>
            </>
          )}
        </Stack>
      </PlanCardLayout>

      <PlanDetailsDialog
        open={Details}
        onClose={handleCloseDialog}
        planDetails={planDetails}
        planDetailsLoading={planDetailsLoading}
      />
    </>
  );
};

export default PlansCard;
